import { render } from "./TemplateEditor.vue?vue&type=template&id=f60d8df0&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"

import "./TemplateEditor.vue?vue&type=style&index=0&id=f60d8df0&scoped=true&lang=scss"
import "./TemplateEditor.vue?vue&type=style&index=1&id=f60d8df0&lang=scss"
import "./TemplateEditor.vue?vue&type=style&index=2&id=f60d8df0&lang=scss"
script.render = render
script.__scopeId = "data-v-f60d8df0"

export default script